import VisuallyHidden from './VisuallyHidden';

// export types
export type { VisuallyHiddenProps } from './VisuallyHidden';

// export components
export { VisuallyHidden };
export default VisuallyHidden;
